import { metricLabel } from "@/components/pages/recommendations/components/rightsizing-recommendations/utils/helpers/metricLabel";
import { RightsizingRecommendationsChartColors } from "@/components/pages/recommendations/components/rightsizing-recommendations/utils/constants/constants";
import { RightsizingRecommendationsChartData } from "@/components/pages/recommendations/components/rightsizing-recommendations/utils/types/types";

export const generateRightsizingHighChartData = (
  data: RightsizingRecommendationsChartData[],
  currentType: string,
  recommendedType: string,
  metric: "average" | "maximum",
) => {
  const categories = data.map((item) => item.timestamp);
  const cpuData = data.map((item) => item.cpu);
  const recommendedData = data.map((item) => item.recommended);

  return {
    categories,
    series: [
      {
        name: `${currentType} ${metricLabel(metric)} CPU % (Current)`,
        data: cpuData,
        color: RightsizingRecommendationsChartColors.CpuArea,
        type: "area",
      },
      {
        name: `${recommendedType} ${metricLabel(metric)} CPU % (Recommended)`,
        data: recommendedData,
        color: RightsizingRecommendationsChartColors.RecommendedSize,
        type: "area",
        fillOpacity: 0.3,
      },
    ],
  };
};
